import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-bulk',
  templateUrl: './icon-bulk.component.html',
  styleUrls: ['./icon-bulk.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBulkComponent {}
